const { setStore } = require('./core/connect');
const { store } = require('./core/store');
const adapters = require('./core/adapters');
const actions = require('./core/actions');
const { ConnectedOptinButton } = require('./components/OptinButton');
const { ConnectedOptoutButton } = require('./components/OptoutButton');
const { ConnectedOptinSelect } = require('./components/OptinSelect');
const { ConnectedUpsellButton } = require('./components/UpsellButton');
const { ConnectedUpsellModal } = require('./components/UpsellModal');
const { ConnectedOptinToggle } = require('./components/OptinToggle');
const { ConnectedOptinStatus } = require('./components/OptinStatus');
const { ConnectedText } = require('./components/Text');
const { ConnectedSelectFrequency } = require('./components/SelectFrequency');
const { ConnectedNextUpcomingOrder } = require('./components/NextUpcomingOrder');
const { ConnectedOffer } = require('./components/Offer');
const { Modal } = require('./components/Modal');
const { Select } = require('./components/Select');
const { Tooltip } = require('./components/Tooltip');
const { ConnectedFrequencyStatus } = require('./components/FrequencyStatus');

const offers = {
  setEnvironment(e) {
    store.dispatch(actions.setEnvironment(e));
    return offers;
  },
  setMerchantId(m) {
    store.dispatch(actions.setMerchantId(m));
    return offers;
  },
  setAuthUrl(authUrl) {
    store.dispatch(actions.setAuthUrl(authUrl));
    return offers;
  },
  getProductsForPurchasePost(productIds = []) {
    if (Array.isArray(productIds)) {
      throw new Error('first argument of getProductsForPurchasePost must be an array');
    }
    return adapters.getProductsForPurchasePost(store.getState(), productIds);
  },
  getOptins(productIds = []) {
    return adapters.getProductsForPurchasePost(store.getState(), productIds);
  },
  clear() {
    store.dispatch(actions.checkout());
  },
  addOptinChangedCallback(fn) {
    if (typeof fn === 'function') document.addEventListener('optin-changed', e => fn(e.detail));
  },
  disableOptinChangedCallbacks() {
    document.addEventListener('optin-changed', e => e.stopPropagation(), true);
  },
  register() {
    try {
      customElements.define('og-text', ConnectedText);
      customElements.define('og-offer', ConnectedOffer);
      customElements.define('og-select-frequency', ConnectedSelectFrequency);
      customElements.define('og-optout-button', ConnectedOptoutButton);
      customElements.define('og-optin-toggle', ConnectedOptinToggle);
      customElements.define('og-optin-status', ConnectedOptinStatus);
      customElements.define('og-optin-button', ConnectedOptinButton);
      customElements.define('og-optin-select', ConnectedOptinSelect);
      customElements.define('og-upsell-button', ConnectedUpsellButton);
      customElements.define('og-frequency-status', ConnectedFrequencyStatus);
      customElements.define('og-modal', Modal);
      customElements.define('og-select', Select);
      customElements.define('og-tooltip', Tooltip);
      customElements.define('og-upsell-modal', ConnectedUpsellModal);
      customElements.define('og-next-upcoming-order', ConnectedNextUpcomingOrder);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
    offers.register = () => 0;
  },
  /**
   * Initialize OG object
   * @param {*} merchantId
   * @param {*} env
   * @param {*} authUrl
   */
  initialize(merchantId, env, authUrl) {
    setStore(store);
    if (merchantId) offers.setMerchantId(merchantId);
    if (env) offers.setEnvironment(env);
    if (authUrl) offers.setAuthUrl(authUrl);

    if (merchantId && env) {
      store.dispatch(actions.requestSessionId());
      store.dispatch(actions.fetchAuth());
      offers.register();
    }

    return offers;
  },
  config(configuration) {
    store.dispatch(actions.setConfig(configuration));
    return offers;
  },
  setLocale(locale) {
    store.dispatch(actions.setLocale(locale));
    return offers;
  }
};
window.OG = window.OG || {};
Object.assign(window.OG, offers);
Object.assign(offers.initialize, offers);
// use this syntax to allow es6 module be called as default functino og.offers(...)
module.exports = offers.initialize;
